export default "__VITE_ASSET__DSN_uWL4__"